import { onMounted, onBeforeUnmount, nextTick, watch } from 'vue';
import Sortable from 'sortablejs';

// getOptions() returning a falsy value means dragging is currently disabled.
// watchSources are re-checked to reinit (destroy + recreate) the instance, e.g. when
// the container's item count or the enabled/disabled condition changes.
export function useSortable(containerRef, getOptions, watchSources = []) {
  let instance = null;

  // containerRef may hold a plain DOM element (e.g. a ref="x" on a <div>) or a component
  // instance whose ref resolves to its proxy instead of its root node (e.g. <transition-group>) —
  // both are normalized to the underlying element here.
  function resolveEl() {
    const target = containerRef.value;
    return target && target.$el ? target.$el : target;
  }

  function destroy() {
    if (instance) {
      instance.destroy();
      instance = null;
    }
  }

  function init() {
    destroy();
    const options = getOptions();
    const el = resolveEl();
    if (!options || !el) return;
    instance = new Sortable(el, options);
  }

  function reinit() {
    nextTick(init);
  }

  onMounted(reinit);
  onBeforeUnmount(destroy);

  (Array.isArray(watchSources) ? watchSources : [watchSources]).forEach(source => watch(source, reinit));

  return { reinit, destroy };
}
